export default __webpack_public_path__ + "static/media/logo-slice-factory.5034be72.png";